import React, { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import ComplianceStackGame from "../components/ComplianceStackGame";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const lenis = new Lenis();
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[var(--ink)] text-[var(--cream)] min-h-screen">
      <SEO title="Terms & Conditions" description="Terms and Conditions for Meraki Solutions." />
      <Navbar />
      
      <main className="pt-44 pb-32">
        <div className="container-xl px-4 md:px-6 max-w-4xl mx-auto">
          <h1 className="font-display text-4xl md:text-7xl mb-12 balance">Terms & <span className="italic gold-text">Conditions</span></h1>
          <div className="space-y-8 text-[var(--cream-muted)] leading-relaxed font-body">
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">1. Engagement</h2>
              <p>By using this website or contacting Meraki Solutions, you agree to engage with our boutique studio in a professional and collaborative manner.</p>
            </section>
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">2. Intellectual Property</h2>
              <p>All creative work, including films, designs, and code displayed on this site, are the intellectual property of Meraki Solutions or our respective partners. Unauthorized reproduction is strictly prohibited.</p>
            </section>
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">3. Project Agreements</h2>
              <p>Specific project terms, timelines, and deliverables are governed by individual client contracts. This website serves as a portfolio and inquiry platform.</p>
            </section>
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">4. Governing Law</h2>
              <p>These terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts in Bhopal, Madhya Pradesh.</p>
            </section>
          </div>
        </div>
      </main>

      <ComplianceStackGame />

      <Footer />
    </div>
  );
};

export default Terms;
